import React, { useState, useRef, lazy, Suspense, useContext, useEffect } from 'react';
import ReactiveButton from 'reactive-button';
import { IconContext } from 'react-icons';
import { ReactTyped } from 'react-typed';
import { Image } from 'antd';
import { useReactToPrint } from 'react-to-print'
import { ThemeContext } from '../contexts/ThemeContext';
const LazyPrintable = lazy(() => import('./Printable/Printable'));

const Profile = ({ Data, i18 }) => {
  const [showPrint, setShowPrint] = useState(false);
  const printRef = useRef();
  const [, , resumeMode] = useContext(ThemeContext);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'p') {
        e.preventDefault();
        setShowPrint(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);


  const triggerPrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: i18.FILE_NAME,
    onAfterPrint: () => setShowPrint(false),
  });

  const handlePrint = () => {
    setShowPrint(true);
  };

  return (
    <React.Fragment>
      <div className="profile-page">
        <div className="wrapper">
          <div className="page-header page-header-small" filter-color="theme">
            <div
              className="page-header-image"
              style={{
                loading: "lazy",
                objectFit: "cover",
                backgroundImage: "url('assets/img/banner.png')",
              }}
            ></div>
            <div className="container">
              <div className="content-center">
                <div className="cc-profile-image">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#">
                    <Image
                      src={`assets/img/avatar.png`}
                      loading="lazy"
                      style={{
                        width: '180px',
                        maxWidth: '180px',
                        height: 'auto',
                      }}
                      preview={true}
                      placeholder={
                        <Image
                          preview={false}
                          src={`assets/img/luisarias-min.jpg`}
                        />
                      }
                    />
                  </a>
                </div>
                {Data.about.openToWork && (
                  <div
                    className="cc-profile-image"
                    style={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      width: '100%',
                    }}
                  >
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a href="#">
                      <Image
                        src={`assets/img/open-to-work.png`}
                        style={{
                          top: '1px',
                          width: '100%',
                          maxWidth: '181px',
                          height: 'auto',
                        }}
                        preview={false}
                      />
                    </a>
                  </div>
                )}

                <div className="h2 title">{Data.about.name}</div>
                <p className="category text-white">
                  <ReactTyped
                    className="font-weight-light"
                    strings={
                      Data.about.taglines && Data.about.taglines.length
                        ? Data.about.taglines
                        : ['']
                    }
                    typeSpeed={70}
                    backSpeed={40}
                    smartBackspace={true}
                    loop={true}
                  />
                </p>
                {!Data.about.hideCv && resumeMode && (
                  <div>
                    {/* PRINT */}

                    <ReactiveButton
                      style={{ fontSize: '0.8571em' }}
                      idleText={i18.LBL_CV}
                      className="mt-4"
                      onClick={() => {
                        handlePrint()
                        // navigate('/print');
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="section">
              <div className="container">
                <div className="button-container">
                  {Data.socialLinks.map((socialLink, index) => (
                    <a
                      key={index}
                      className="btn btn-default btn-round btn-lg btn-icon center-this"
                      href={socialLink.link}
                      target="_blank"
                      title={socialLink.title}
                      rel="noopener noreferrer"
                    >
                      <IconContext.Provider value={{ size: '1.4rem' }}>
                        {socialLink.icon}
                      </IconContext.Provider>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPrint && (
        <div style={{ display: 'none' }}>
          <Suspense fallback={null}>
            <LazyPrintable ref={printRef} Data={Data} i18={i18} triggerPrint={triggerPrint} />
          </Suspense>
        </div>
      )}

    </React.Fragment>
  );
};

export default Profile;
